
import React from 'react';
import classNames from 'classnames';
import {Routes} from 'constants/index';
import {navigate} from 'gatsby';
import {usePermissions} from 'hooks/usePermissions';

import * as styles from './styles.module.scss';

export const Logout = () => {
	const {auth} = usePermissions();

	const btnClass = classNames(styles.text, styles.clickable);
	const onClick = () => {
		auth.setToken(null);
		navigate(Routes.signIn);
	};

	return (
		<div className={styles.group}>
			<div className={btnClass} onClick={onClick}>
				Log out
			</div>
		</div>
	);
};
